import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import type { Product } from '@/lib/api.types'

import { getProductDescription, getProductFullDescription } from '../productPresentation'
import {
  ProductDescriptionPreviewMoreButton,
  ProductDescriptionPreviewText,
  ProductDescriptionPreviewWrapper
} from './ProductDescriptionPreview.styles'

interface ProductDescriptionPreviewProps {
  product: Product
  onMore: () => void
  className?: string
}

const ProductDescriptionPreview = ({ product, onMore, className }: ProductDescriptionPreviewProps) => {
  const { t } = useTranslation()

  const description = useMemo(() => getProductDescription(product), [product])
  const fullDescription = useMemo(() => getProductFullDescription(product), [product])
  const hasExtendedDescription = fullDescription && fullDescription.length > 0

  return (
    <ProductDescriptionPreviewWrapper className={className}>
      <ProductDescriptionPreviewText>{description || '-'}</ProductDescriptionPreviewText>
      {hasExtendedDescription && (
        <ProductDescriptionPreviewMoreButton type="button" onClick={onMore}>
          {t('more')}
        </ProductDescriptionPreviewMoreButton>
      )}
    </ProductDescriptionPreviewWrapper>
  )
}

export default ProductDescriptionPreview
